import { buildB2BNavigationModel } from './B2B/buildNavigationModel'
import { buildB2CNavigationModel } from './B2C/buildNavigationModel'
import {
  NAVIGATION_MODEL_VARIANT,
  type NavigationData,
} from './navigationModel'
import type { BuildNavigationModelOptions } from './types'

export const buildNavigationModel = ({
  variant,
  ...options
}: BuildNavigationModelOptions): NavigationData => {
  if (variant === NAVIGATION_MODEL_VARIANT.B2C) {
    return buildB2CNavigationModel({ variant, ...options })
  }

  return buildB2BNavigationModel({ variant, ...options })
}
